<script setup lang="ts">
import VFlex from "addeus-common-library/components/base/flex/VFlex.vue";

export interface OptionCardProps {
    name?: string;
    title?: string;
    titleIcon?: string;
    content?: string;
    price?: number;
}

const props = withDefaults(defineProps<OptionCardProps>(), {
    name: "DEFAULT_NAME",
    title: "DEFAULT_TITLE",
    content: "DEFAULT_CONTENT",
    price: undefined,
});
</script>

<template>
    <VFlex
        flex-direction="row"
        class="has-border-primary has-gradient-background-ttb has-border-radius option">
        <span
            class="has-text-vertical has-text-centered has-background-primary is-size-5 p-3 has-text-weight-bold is-uppercase"
            style="transform: rotate(180deg)">
            {{ props.name }}
        </span>
        <VFlex flex-direction="column" class="p-5 is-flex-grow-1">
            <VFlex flex-direction="row" align-items="center">
                <img
                    v-if="props.titleIcon"
                    :src="titleIcon"
                    alt="titleIcon"
                    class="mr-4"
                    style="width: 40px" />
                <span
                    class="is-size-5 has-text-primary is-uppercase my-2 pl-1 has-text-weight-bold">
                    {{ props.title }}
                </span>
            </VFlex>
            <VDivider color="primary"></VDivider>
            <p class="is-size-5 has-text-white is-flex">
                {{ props.content }}
            </p>
            <VDivider color="primary"></VDivider>
            <PackPrice
                class="is-size-5 has-text-weight-bold"
                :price="props.price"
                :text-style="{ color: 'primary', size: '5' }"
                :price-style="{ color: 'primary', size: '5' }"
                sign="+" />
        </VFlex>
    </VFlex>
</template>

<style lang="scss" scoped>
.option {
    background: radial-gradient(circle, $dark 0%, $blue 100%);
    background-size: 200% 200%;
    animation: gradient 20s ease infinite;

    &:nth-child(1) {
        animation-delay: 0.25s;
    }

    &:nth-child(2) {
        animation-delay: 0.5s;
    }
}

@keyframes gradient {
    0% {
        background-position: 0% 100%;
    }

    50% {
        background-position: 100% 0%;
    }

    100% {
        background-position: 0% 100%;
    }
}
</style>